const Getters = {
    isAuthenticated(state) {
        return state.authenticated;
    },
    getActivePropertyowners(state) {
        if(state.property_owners){
            const owners = state.property_owners
            return owners.filter((owner)=> owner.local.activated === true);
        }
        return [];
    },
    getPendingPropertyowners(state) {
        if(state.property_owners){
            const owners = state.property_owners
            return owners.filter((owner)=> owner.local.activated === false);
        }
        return [];
    },
    getPendingPropertyManager(state) {
        if(state.property_managers){
            const managers = state.property_managers
            return managers.filter((owner)=> owner.isVerified === false);
        }
        return [];
    },
    getActivePropertyManager(state) {
        if(state.property_managers){
            const managers = state.property_managers
            return managers.filter((owner)=> owner.isVerified === true);
        }
        return [];
    },
    getManagersCount(state) {
        if(state.property_managers){
            return state.property_managers.length;
        }
        return 0;
    },
    authToken(state) {
        return state.token
    },
    getPropertyResidents(state) {
        return state.residents
    },
    getTotalUserCount(state) {
        return state.user_count
    },
    getTotalManagerCount(state) {
        return state.managers_count
    },
};

export default Getters;